<template>
	<app-content>
		<Row :space="16">
			<Cell width="6" v-for="card in cards" :key="card.key">
				<div class="stat-card">
					<div class="stat-card-icon" :style="{background: card.color}">
						<i :class="card.icon"></i>
					</div>
					<div class="stat-card-info">
						<div class="stat-card-title">{{ card.title }}</div>
						<div class="stat-card-value">{{ card.value }}</div>
						<div class="stat-card-sub" v-if="card.sub">{{ card.sub }}</div>
					</div>
				</div>
			</Cell>
		</Row>

		<div class="h-panel margin-top">
			<div class="h-panel-bar"><span class="h-panel-title">近 30 天趋势</span></div>
			<div class="h-panel-body">
				<Chart v-if="!loading" :options="chartOptions"/>
			</div>
		</div>

		<div class="h-panel margin-top">
			<div class="h-panel-bar"><span class="h-panel-title">快捷入口</span></div>
			<div class="h-panel-body">
				<router-link class="blue-color margin-right" to="/admin/account-sets">账套管理</router-link>
				<router-link class="blue-color margin-right" to="/admin/users">用户管理</router-link>
				<router-link class="blue-color margin-right" to="/admin/account-templates">账套模板</router-link>
				<router-link class="blue-color margin-right" to="/admin/renewal-codes">续订代码</router-link>
				<router-link class="blue-color margin-right" to="/admin/payment">收款配置与订单</router-link>
				<router-link class="blue-color" to="/admin/ai-config">智能体配置</router-link>
			</div>
		</div>
	</app-content>
</template>

<script>
	export default {
		name: "AdminDashboard",
		data() {
			return {
				loading: false,
				stats: {}
			}
		},
		computed: {
			cards() {
				return [
					{key: 'user', title: '总用户数', value: this.stats.totalUsers || 0, icon: 'fa fa-users', color: '#1890ff'},
					{key: 'accountSets', title: '账套数', value: this.stats.accountSetsCount || 0, icon: 'fa fa-database', color: '#52c41a', sub: `30天内到期 ${this.stats.expiringCount || 0}`},
					{key: 'weekReg', title: '7天注册用户', value: this.stats.weekRegistrations || 0, icon: 'fa fa-user-plus', color: '#fa8c16'},
					{key: 'weekActive', title: '7天活跃用户', value: this.stats.weekActiveUsers || 0, icon: 'fa fa-line-chart', color: '#722ed1'},
					{key: 'renewalTotal', title: '续订码总量', value: this.stats.renewalTotal || 0, icon: 'fa fa-key', color: '#13c2c2'},
					{key: 'renewalUsed', title: '已核销续订码', value: this.stats.renewalUsed || 0, icon: 'fa fa-check-circle', color: '#eb2f96', sub: `7天核销 ${this.stats.renewalWeek || 0}`},
					{key: 'voucher', title: '凭证总量', value: this.stats.voucherCount || 0, icon: 'fa fa-file-text', color: '#faad14', sub: `本月 ${this.stats.monthVoucherCount || 0}`}
				];
			},
			chartOptions() {
				let trend = this.stats.dailyTrend || [];
				return {
					tooltip: {trigger: 'axis'},
					legend: {data: ['日注册人数', '新增账套数']},
					grid: {left: 40, right: 20, top: 40, bottom: 30},
					xAxis: {
						type: 'category',
						data: trend.map(item => (item.date || '').substring(5)),
						axisLabel: {interval: 4}
					},
					yAxis: {type: 'value', minInterval: 1},
					series: [
						{
							name: '日注册人数',
							type: 'line',
							smooth: true,
							areaStyle: {opacity: 0.15},
							data: trend.map(item => item.registrations)
						},
						{
							name: '新增账套数',
							type: 'line',
							smooth: true,
							areaStyle: {opacity: 0.15},
							data: trend.map(item => item.accountSets)
						}
					]
				};
			}
		},
		methods: {
			loadStats() {
				this.loading = true;
				this.$api.admin.stats().then(({data}) => {
					this.stats = data || {};
				}).catch(() => {
					this.$Message.error('统计数据加载失败，请稍后重试');
				}).finally(() => {
					this.loading = false;
				});
			}
		},
		mounted() {
			this.loadStats();
		}
	}
</script>

<style scoped lang="less">
	.stat-card {
		background: #fff;
		border-radius: 6px;
		padding: 20px;
		display: flex;
		align-items: center;
		box-shadow: 0 1px 4px rgba(0, 21, 41, 0.06);

		&-icon {
			width: 56px;
			height: 56px;
			border-radius: 8px;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;

			i {
				color: #fff;
				font-size: 24px;
			}
		}

		&-info {
			margin-left: 16px;
			overflow: hidden;
		}

		&-title {
			color: #888;
			font-size: 13px;
		}

		&-value {
			font-size: 26px;
			color: #333;
			font-weight: 600;
			line-height: 1.3;
		}

		&-sub {
			color: #aaa;
			font-size: 12px;
		}
	}
</style>
